/**
 * Request statuses
 */

export const REQUEST_IDLE:string = 'IDLE';
export const REQUEST_LOADING:string = 'LOADING';
export const REQUEST_SUCCEEDED:string = 'SUCCEEDED';
export const REQUEST_FAILED:string = 'FAILED';
